// extracted by mini-css-extract-plugin
export default {"formColumns":"FormColumns_formColumns__v+V73"};